import styled from 'styled-components'

export const ToolTipDescription = styled.div`
  background-color: black;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 6px 8px;
  pointer-events: none;
  opacity: 0;
  transition: all 0.2s var(--cubicBezier);
  cursor: pointer;
  font-weight: var(--font-medium);
  position: absolute;
  line-height: 1.4;
  min-width: 250px;
  width: 100%;
  max-width: 450px;
  z-index: 99;

  @media (max-width: 768px) {
    max-width: 90%;
  }

  ::after {
    content: '';
    position: absolute;
    bottom: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: transparent transparent black transparent;
    pointer-events: none;
  }
`

export const ToolTipIcon = styled.div<{ disabled: boolean }>`
  display: inline;
  margin-left: 5px;
  cursor: pointer;
  position: relative;

  ${({ disabled }) =>
    !disabled &&
    `
    &:hover {
      ${ToolTipDescription} {
        opacity: 1;
      }
    }
  `}
`
